import { FLOOR_COVERING_CONFIGURATION_TYPE } from '../const';

export const getSearchConfigurationsBody = (
  authorizedCustomerId: string | undefined,
  unauthorizedCustomerId: string | undefined
) => ({
  customers: [
    ...(Boolean(authorizedCustomerId)
      ? [
          {
            id: authorizedCustomerId,
            isAuthorized: true,
          },
        ]
      : []),
    ...(Boolean(unauthorizedCustomerId)
      ? [
          {
            id: unauthorizedCustomerId,
            isAuthorized: false,
          },
        ]
      : []),
  ],
  configurationType: FLOOR_COVERING_CONFIGURATION_TYPE,
});
